import { AlienPatron } from "../objects/AlienPatron";
import { AnswerPatronQuestionScene } from "./AnswerPatronQuestionScene";
import { TiledGameObject } from "src/games/shared/phaserHelpers/HandyTypes";
import { Utils } from "../objects/Utils";
import { PhaserButton } from "src/games/shared/Button";
import { GameState } from "../objects/GameState";
import TranslateApi from "src/utils/TranslateHelper";
import bindAllOfThis from "src/utils/BindThisHelper";
import initializeInteractiveCursor from "src/games/shared/InteractiveCursorUtil";
import { Color } from "src/games/shared/ColorValue";
import AudioTranslations from "src/constants/AudioTranslations";

export class ResultsScene extends Phaser.Scene {
    gameWidth: number;
    gameHeight: number;
    background: Phaser.GameObjects.Image;
    map: Phaser.Tilemaps.Tilemap;
    private SCORE_THRESHOLD = 10;

    constructor() {
        super({
            key: "ResultsScene" + Math.random(),
        });
    }

    preload(): void {
        this.load.image("pixel", require("/src/assets/qci/sprites/pixel.png"));
        this.load.tilemapTiledJSON("map", require("/src/assets/qci/maps/hotel_aurora_1.json"));

        this.load.image('lobby_zoomed', require("/src/assets/qci/backgrounds/hotel_lobby_zoomed.jpg"));

        // Alien Patrons
        this.load.image('alien_1', require("/src/assets/qci/sprites/aliens/sleb-normal.png"));
        this.load.image('alien_2', require("/src/assets/qci/sprites/aliens/snib-normal.png"));
        this.load.image('alien_3', require("/src/assets/qci/sprites/aliens/squeelo-normal.png"));

        var keys = [
            "HotelAurora.Phaser.ResultsScene.success1",
            "HotelAurora.Phaser.ResultsScene.success2",
            "HotelAurora.Phaser.ResultsScene.success3",
            "HotelAurora.Phaser.ResultsScene.tryAgain1",
            "HotelAurora.Phaser.ResultsScene.tryAgain2",
            "HotelAurora.Phaser.ResultsScene.tryAgain3"
        ];

        keys.forEach((key) => {
            this.load.audio(key, AudioTranslations.FindByKeyAndLanguage(key, TranslateApi.currentLanguage.code).url);
        });
    }

    create(): void {
        bindAllOfThis(this, ResultsScene.prototype);
        this.initialize();
        this.generateScene();
        initializeInteractiveCursor(this);
    }

    initialize() {
        this.gameWidth = this.textures.game.config.width as number;
        this.gameHeight = this.textures.game.config.height as number;
        this.map = this.make.tilemap({ key: 'map' });
    }

    /**
     * Scene: Patron tells student whether or not they want to stay at Hotel Aurora
     * If they do, student can move on...
     * If they don't, student can start over by meeting a new AlienPatron
     */
    generateScene() {
        this.background = this.add.image(0, 0, "lobby_zoomed");
        this.background.setOrigin(0);
        this.background.setDepth(0);
        this.background.setDisplaySize(this.gameWidth, this.gameHeight);

        var resultText, buttonText;
        var gameOver = false;
        var patron = AlienPatron.ALL_PATRONS[GameState.current.alienIndex];
        var translateString = "HotelAurora.Phaser.ResultsScene.";
        var key;

        if (GameState.current.score >= this.SCORE_THRESHOLD) {
            // Patron decided to stay at Hotel Aurora
            resultText = TranslateApi.translate(translateString + "success" + patron.id);
            buttonText = TranslateApi.translate("common.done");
            key = translateString + "success" + patron.id;
            gameOver = true;
        }
        else {
            // Choose not to stay
            resultText = TranslateApi.translate(translateString + "tryAgain" + patron.id);
            buttonText = TranslateApi.translate(translateString + "tryAgainButton");
            key = translateString + "tryAgain" + patron.id;
        }

        var audio = this.sound.add(key);
        audio.play();


        this.map.getObjectLayer("Patron Decision Layer").objects.forEach((ob: TiledGameObject) => {
            if (ob.name === "npc") {
                var patronImage = this.add.image(ob.x, ob.y, "npc");
                patronImage.setOrigin(0);
                patronImage.setDisplaySize(ob.width, ob.height);
            }
            else if (ob.name === "dialog") {
                var text = Utils.createDialog(this, ob, resultText);
            }
            else if (ob.name === "button") {
                var config = Utils.getButtonConfig();
                config.backgroundColor = Color.KUDER_PRIMARY_BUTTON;
                config.smartSize = true;
                config.keyMapping = "keydown_RIGHT";
                var button = new PhaserButton(this, ob.x, ob.y, ob.width, ob.height, buttonText, config);
                button.setX(this.gameWidth - button.width - 50);
                button.on("buttonClicked", () => {
                    this.input.enabled = false;
                    this.sound.stopAll();
                    if (gameOver) {
                        // Game Over
                        (this.sys.game as any).onComplete();
                    }
                    else {
                        // Restart game with new patron
                        var newAlienIndex = (GameState.current.alienIndex + 1) % AlienPatron.ALL_PATRONS.length;
                        GameState.current.alienIndex = newAlienIndex;
                        GameState.current.dialogIndex = 0;
                        GameState.current.score = 0;
                        Utils.scrambleResponses(AlienPatron.ALL_PATRONS[newAlienIndex]);
                        this.scene.add("AnswerPatronQuestionScene", AnswerPatronQuestionScene, true);
                        this.scene.remove(this);
                    }
                });
            }
        });
    }


}



// WEBPACK FOOTER //
// ./src/games/HotelAuroraGame/scenes/ResultsScene.ts